export default __webpack_public_path__ + "static/media/Fabrizio Bosso.44f7254b.jpg";